import { render, staticRenderFns } from "./tabLclUnitLoadDevice.vue?vue&type=template&id=23551b54&"
import script from "./tabLclUnitLoadDevice.vue?vue&type=script&lang=js&"
export * from "./tabLclUnitLoadDevice.vue?vue&type=script&lang=js&"
import style0 from "./tabLclUnitLoadDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23551b54')) {
      api.createRecord('23551b54', component.options)
    } else {
      api.reload('23551b54', component.options)
    }
    module.hot.accept("./tabLclUnitLoadDevice.vue?vue&type=template&id=23551b54&", function () {
      api.rerender('23551b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabLclUnitLoadDevice.vue"
export default component.exports